module.exports = __webpack_public_path__ + "static/media/Хакимов А. (НУ).107a504d.pdf";